<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group
        :submissionId="submissionId"
        :formLabel="'Storage Bin'"
      />
      <project-potato-field-form-group :submissionId="submissionId" />
      <div v-if="samples && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <project-potato-sample-form-group
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            @updateSampleList="updateSampleList"
          />
        </template>
      </div>
      <div>
        <b-row class="mb-2" align-h="end">
          <b-col class="pr-0" cols="2">
            <b-button
              variant="success"
              block
              @click="updateSampleList({ action: 'add' })"
            >
              <i class="fa fa-plus" /> Add
            </b-button>
          </b-col>
          <b-col cols="3">
            <b-input-group append="Sample(s)" :horizontal="true">
              <b-form-input
                type="number"
                min="1"
                v-model="new_samples_quantity"
                @change="handleQuantityChange"
              />
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question :key="index" :serviceQuestion="question" />
        </template>
      </div>
    </b-card>
  </div>
</template>
<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectPotatoFieldFormGroup from "./ProjectPotatoFieldFormGroup";
import ProjectPotatoSampleFormGroup from "./ProjectPotatoSampleFormGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "ProjectPotatoSubmissionForm",
  components: {
    ProjectFieldFormGroup,
    ProjectPotatoFieldFormGroup,
    ProjectPotatoSampleFormGroup,
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    serviceQuestions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    isValid() {
      return this.$v && !this.$v.$invalid;
    },
  },
  data() {
    return {
      new_samples_quantity: null,
    };
  },
  validations: {
    currentSubmission: {
      test_package_id: { required },
      samples: { required, minLength: minLength(1) },
    },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleQuantityChange(value) {
      this.new_samples_quantity = value;
    },
    updateSampleList({ action, sample_id }) {
      let sample_list_update = [...this.samples];
      switch (action) {
        case "duplicate": {
          const duplicated_sample = this.samples.find(
            (sample) => sample.test_package_sample_id === sample_id
          );
          const duplicated_sample_index = this.samples.findIndex(
            (sample) => sample.test_package_sample_id === sample_id
          );
          sample_list_update.splice(duplicated_sample_index + 1, 0, {
            ...duplicated_sample,
            identifier: `Sample ${duplicated_sample_index + 2}`,
            test_package_sample_id: this.$uuid.v4(),
          });
          break;
        }
        case "remove": {
          sample_list_update = this.samples.filter(
            (sample) => sample.test_package_sample_id !== sample_id
          );
          break;
        }
        case "add": {
          if (this.new_samples_quantity) {
            const last_sample = this.samples.find(
              (sample, index) => index + 1 === this.samples.length
            );
            let counter = 0;
            while (counter < this.new_samples_quantity) {
              counter++;
              sample_list_update = [
                ...sample_list_update,
                {
                  ...last_sample,
                  identifier: `Sample ${this.samples.length + counter}`,
                  test_package_sample_id: this.$uuid.v4(),
                },
              ];
            }
          }
          break;
        }
        default:
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: sample_list_update,
        name: "samples",
      });
      this.new_samples_quantity = null;
    },
  },
};
</script>
